import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-white" }, "IOM-Dashboard")
  ])
], -1)
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "pl-4 text-xs font-semibold mb-4 text-gray-400" }, "Menu Utama", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Dashboard", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "pl-4 my-2 text-xs font-semibold mb-4 text-gray-400" }, " Menu Lainnya ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Kegiatan", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Merchandise", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "10 Donasi Terakhir", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Donasi", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Pengajuan Bantuan", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Pendataan Anggota", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Orangtua Asuh", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Dana Bantuan", -1)

import { ref } from "vue";
import { useSidebar } from "../hooks/useSidebar";
import IcUser from "@/assets/svg/ic-user.vue";
import IcCard from "@/assets/svg/ic-card.vue";
import IcBag from "@/assets/svg/ic-bag.vue";
import IcGrafic from "@/assets/svg/ic-grafic.vue";
import IcHome from "@/assets/svg/ic-home.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isOpen } = useSidebar();
const activeClass = ref(
  "bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100"
);
const inactiveClass = ref(
  "border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100"
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'translate-x-0 ease-out' : '-translate-x-full ease-in', "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _hoisted_2,
      _createElementVNode("nav", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Dashboard' ? activeClass.value : inactiveClass.value]]),
          to: "/dashboard"
        }, {
          default: _withCtx(() => [
            _createVNode(IcHome),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["class"]),
        _hoisted_6,
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Kegiatan' ? activeClass.value : inactiveClass.value]]),
          to: "/kegiatan"
        }, {
          default: _withCtx(() => [
            _createVNode(IcGrafic),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Merchandise' ? activeClass.value : inactiveClass.value]]),
          to: "/merchandise"
        }, {
          default: _withCtx(() => [
            _createVNode(IcBag),
            _hoisted_8
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Donasi Trakhir' ? activeClass.value : inactiveClass.value]]),
          to: "/10-donasi-terakhir"
        }, {
          default: _withCtx(() => [
            _createVNode(IcUser),
            _hoisted_9
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Donasi' ? activeClass.value : inactiveClass.value]]),
          to: "/donasi"
        }, {
          default: _withCtx(() => [
            _createVNode(IcUser),
            _hoisted_10
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Pengajuan Bantuan' ? activeClass.value : inactiveClass.value]]),
          to: "/pengajuan-bantuan"
        }, {
          default: _withCtx(() => [
            _createVNode(IcUser),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Pendataan Anggota' ? activeClass.value : inactiveClass.value]]),
          to: "/pendataan-anggota"
        }, {
          default: _withCtx(() => [
            _createVNode(IcUser),
            _hoisted_12
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Orangtua Asuh' ? activeClass.value : inactiveClass.value]]),
          to: "/orangtua-asuh"
        }, {
          default: _withCtx(() => [
            _createVNode(IcUser),
            _hoisted_13
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Dana Bantuan' ? activeClass.value : inactiveClass.value]]),
          to: "/dana-bantuan"
        }, {
          default: _withCtx(() => [
            _createVNode(IcCard),
            _hoisted_14
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ], 2)
  ]))
}
}

})